// extracted by mini-css-extract-plugin
export default {"spHeader_breadCrumb":"HeaderMain_spHeader_breadCrumb__4B2dN"};